import { bindEvents } from '../../assets/js/helpers';


const selector = 'share';

export default class Share {

	constructor(section) {
		this.el = {
			section,
			input: section.querySelector(`.${selector}__input input`)
		};

		this.timeout = null;

		this.events = bindEvents(this);

		this.addEventListeners();
	}

	static get selector() {
		return selector;
	}

	_onInputClick(e) {
		e.preventDefault();
		const range = document.createRange();

		this.el.input.contentEditable = true;
		this.el.input.readOnly = false;
		range.selectNodeContents(this.el.input);

		const s = window.getSelection();
		s.removeAllRanges();
		s.addRange(range);

		this.el.input.setSelectionRange(0, 999999);

		document.execCommand('copy');

		const cmd = document.execCommand('copy');
		if (cmd) {
			this.el.input.classList.add('is-copied');
			if (this.timeout) clearTimeout(this.timeout);
			this.timeout = setTimeout(() => this.el.input.classList.remove('is-copied'), 500);
		}

		this.el.input.blur();
	}

	addEventListeners() {
		this.el.input.addEventListener('click', this.events._onInputClick);
	}

	removeEventListeners() {
		this.el.input.removeEventListener('click', this.events._onInputClick);
	}

}
